<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="header">
      <img class="logo" src="../../assets/logo (2).png" alt="" />
      <img class="text" src="../../assets/text(1).png" alt="" />
    </div>
    <div class="container">
      <div class="left-advertising">
        <ul class="square-one">
          <li>
            <a href=""><img src="../../assets/layer1.png" alt="" /></a>
          </li>
          <li>
            <img src="../../assets/layer2.png" alt="" />
          </li>
        </ul>
        <ul class="square-two">
          <li><img src="../../assets/layer3.png" alt="" /></li>
          <li><img src="../../assets/layer4.png" alt="" /></li>
          <li><img src="../../assets/layer5.png" alt="" /></li>
        </ul>
        <ul class="square-three">
          <li><img src="../../assets/layer6.png" alt="" /></li>
          <li><img src="../../assets/layer7.png" alt="" /></li>
          <li><img src="../../assets/layer8.png" alt="" /></li>
        </ul>
        <ul class="square-four">
          <li><img src="../../assets/layer9.png" alt="" /></li>
          <li><img src="../../assets/layer10.png" alt="" /></li>
        </ul>
        <div class="fd"></div>
      </div>

      <route-view></route-view>
    </div>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'UserLayout',
  components: { RouteView },
  mixins: [mixinDevice],
  data() {
    return {}
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 650px;
    background: url(~@/assets/bcg.png) no-repeat;
    background-size: cover;
    position: relative;

    a {
      text-decoration: none;
    }

    .top {
      text-align: center;

      .header {
        height: 44px;
        line-height: 44px;

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.8;
        }

        .logo {
          height: 44px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
        }

        .title {
          font-size: 33px;
          color: rgba(0, 0, 0, 0.85);
          font-family:
            'Chinese Quote',
            -apple-system,
            BlinkMacSystemFont,
            'Segoe UI',
            'PingFang SC',
            'Hiragino Sans GB',
            'Microsoft YaHei',
            'Helvetica Neue',
            Helvetica,
            Arial,
            sans-serif,
            'Apple Color Emoji',
            'Segoe UI Emoji',
            'Segoe UI Symbol';
          font-weight: 600;
          position: relative;
          top: 2px;
        }
      }
      .desc {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.45);
        margin-top: 12px;
        margin-bottom: 40px;
      }
    }

    .main {
      min-width: 260px;
      width: 360px;
      border-radius: 4px;
      position: absolute;
      right: 12%;
      top: 80px;
      background: #fff;
    }

    .footer {
      position: absolute;
      width: 100%;
      bottom: 0;
      padding: 0 16px;
      margin: 48px 0 24px;
      text-align: center;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.45);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
      }
    }
    .left-advertising {
      position: absolute;
      left: 12%;
      top: 80px;
      .square-one {
        float: left;
        margin-top: 185px;
        padding: 0;
        img {
          width: 90px;
          margin-top: 45px;
          margin-left: 10px;
        }
      }
      .square-two {
        float: left;
        margin-top: 15px;
        margin-left: -16px;
        padding: 0;
        img {
          width: 90px;
          margin-top: 45px;
          margin-left: 15px;
        }
      }
      .square-three {
        float: left;
        padding: 0;
        margin-top: 73px;
        margin-left: -16px;
        img {
          width: 90px;
          margin-top: 45px;
          margin-left: 10px;
        }
      }
      .square-four {
        float: left;
        padding: 0;
        margin-top: 130px;
        margin-left: -16px;
        img {
          width: 90px;
          margin-top: 45px;
          margin-left: 10px;
        }
      }
      li {
        background: url(~@/assets/square.png) no-repeat 100%;
        background-size: 100%;
        height: 115px;
        width: 115px;
        list-style: none;
        cursor: pointer;
        transition: all 0.3s ease-out;
        transition: all 0.3s ease-in;
        &:hover {
          transform: scale(1.2);
        }
      }
    }
  }
}
.header {
  .logo {
    margin-left: 260px;
    padding: 20px 0 20px 0;
    width: 10%;
  }
  .text {
    margin-left: 50px;
  }
}
.fd {
  clear: both;
}
</style>
